import React, { useEffect, useState } from 'react';
import { toast } from 'react-toastify';
import { authAxios } from '../../config/config';
import { PhotoIcon, UserCircleIcon, TrashIcon, PlusCircleIcon } from '@heroicons/react/24/solid';
import { useTranslation } from 'react-i18next';
import { correctContactValue } from '../../Helper/helper';

const AddRestaurant = ({ handleCancel, handleAdd, allmodel, handleUpdate }) => {
  const { i18n } = useTranslation();
  const isRTL = i18n.language === 'ar';
  const [formData, setFormData] = useState({
    name: { en: '', ar: '' },
    about: { en: '', ar: '' },
    location: { en: '', ar: '' },
    discountUrl: '',
    contactNumber: '',
    menus: [],
    gallery: [],
    rating: '',
    discountMessage: '',
    website: "",
    facebook: "",
    instagram: "",
    twitter: "",
    youtube: "",
    email: ""
  });

  const handleImageUpload = async (field, files) => {
    const uploadedImages = [];
    const uploadPromises = Array.from(files).map(async (file) => {
      const formData = new FormData();
      formData.append('file', file);
      try {
        const response = await authAxios().post('/admin/upload/single', formData);
        uploadedImages.push(response.data.data.url);
        toast.success('Image uploaded successfully!');
      } catch (error) {
        toast.error('Failed to upload image.');
      }
    });

    await Promise.all(uploadPromises);
    setFormData((prev) => ({
      ...prev,
      [field]: [...prev[field], ...uploadedImages]
    }));
  };

  const handleRemoveImage = (field, index) => {
    setFormData((prev) => ({
      ...prev,
      [field]: prev[field].filter((_, i) => i !== index)
    }));
  };

  const handleRatingChange = (e) => {
    const value = e.target.value;

    // Function to validate if input is between 1 and 5
    const isValidRating = (input) => {
      const ratingRegex = /^[1-5]$/; // Matches only numbers 1 to 5
      return ratingRegex.test(input);
    };

    // Allow clearing the input
    if (value === "") {
      setFormData((prev) => ({ ...prev, rating: "" }));
      return;
    }

    // Validate input using regex and update state
    if (isValidRating(value)) {
      setFormData((prev) => ({ ...prev, rating: value }));
    }
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    // const payload = {
    //   name: formData.name,
    //   about: formData.about,
    //   email:formData.email,
    //   location: formData.location,
    //   discountUrl: formData.discountUrl,
    //   menus: formData.menus,
    //   gallery: formData.gallery,
    //   rating: formData.rating,
    //   discountMessage: formData?.discountMessage
    // };

    const payload = { ...formData }


    console.log('adfadf', payload)

    if (allmodel?.data?._id) {
      handleUpdate(payload);
    } else {
      handleAdd(payload);
    }
  };


  useEffect(() => {
    if (allmodel?.data?._id) {
      setFormData({
        ...formData,
        name: allmodel.data.name || { en: '', ar: '' },
        about: allmodel.data.about || { en: '', ar: '' },
        location: allmodel.data.location || { en: '', ar: '' },
        discountUrl: allmodel.data.discountUrl || '',
        contactNumber: allmodel.data.contactNumber || '',
        menus: allmodel.data.menus || [],
        gallery: allmodel.data.gallery || [],
        rating: allmodel.data.rating || 0,
        discountMessage: allmodel.data.discountMessage || { en: '', ar: '' },


      });
    }
  }, [allmodel]);

  return (
    <div className="fixed inset-0 z-10">
      <div className="fixed inset-0 bg-gray-500/75 transition-opacity"></div>

      <div className="fixed inset-0 z-10 w-screen overflow-y-auto">
        <div className="flex min-h-screen items-center justify-center p-4 sm:p-6 lg:p-8 text-center">
          <div className="relative transform overflow-hidden bg-white rounded-lg shadow-xl transition-all sm:my-8 sm:w-full sm:max-w-lg">
            <div className="px-6 py-8">
              <h2 className="text-lg font-medium text-gray-900 mb-6">
                {allmodel?.data?._id ? 'Update Restaurant' : 'Add Restaurant'}
              </h2>
              <div className="flex items-center gap-4">
                <label className="flex-1 text-sm font-medium text-gray-900 flex items-center justify-start mb-2"></label>
                <label className="flex-1 text-sm font-medium text-gray-900 flex items-center justify-start mb-2">English </label>
                <label className="flex-1 text-sm font-medium text-gray-900 flex items-center justify-start mb-2">Arabic</label>
              </div>

              <form onSubmit={handleSubmit} className="space-y-6">
                {/* Name, About, and Location */}
                {['name', 'about'].map((key) => (
                  <div key={key} className="flex gap-4">
                    <label className="w-1/4 text-sm font-medium text-gray-900 text-justify">
                      {key.charAt(0).toUpperCase() + key.slice(1)}
                    </label>

                    {key === 'about' ? (
                      <div className="flex flex-col w-full">
                        <textarea
                          required
                          placeholder={`${key} (EN)`}
                          value={formData[key]?.en || ''}
                          onChange={(e) =>
                            setFormData((prev) => ({
                              ...prev,
                              [key]: { ...prev[key], en: e.target.value }
                            }))
                          }
                          className="flex-1 mb-4 rounded-md bg-white px-4 py-3 text-gray-900 outline outline-1 -outline-offset-1 outline-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-indigo-600 focus:ring-offset-2 sm:text-sm"
                          rows={5}
                        />
                        <textarea
                          required
                          placeholder={`${key} (AR)`}
                          value={formData[key]?.ar || ''}
                          onChange={(e) =>
                            setFormData((prev) => ({
                              ...prev,
                              [key]: { ...prev[key], ar: e.target.value }
                            }))
                          }
                          className="flex-1 rounded-md bg-white px-4 py-3 text-gray-900 outline outline-1 -outline-offset-1 outline-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-indigo-600 focus:ring-offset-2 sm:text-sm"
                          rows={5}
                        />
                      </div>
                    ) : (
                      <>
                        <input
                          required
                          type="text"
                          placeholder={`${key} (EN)`}
                          value={formData[key]?.en || ''}
                          onChange={(e) =>
                            setFormData((prev) => ({
                              ...prev,
                              [key]: { ...prev[key], en: e.target.value }
                            }))
                          }
                          className="flex-1 rounded-md bg-white px-4 py-3 text-gray-900 outline outline-1 -outline-offset-1 outline-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-indigo-600 focus:ring-offset-2 sm:text-sm"
                        />
                        <input
                          required
                          type="text"
                          placeholder={`${key} (AR)`}
                          value={formData[key]?.ar || ''}
                          onChange={(e) =>
                            setFormData((prev) => ({
                              ...prev,
                              [key]: { ...prev[key], ar: e.target.value }
                            }))
                          }
                          className="flex-1 rounded-md bg-white px-4 py-3 text-gray-900 outline outline-1 -outline-offset-1 outline-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-indigo-600 focus:ring-offset-2 sm:text-sm"
                        />
                      </>
                    )}
                  </div>
                ))}


                {['location', 'discountMessage'].map((key) => (
                  <div key={key} className="flex items-center gap-4">
                    <label className="w-1/4 text-sm font-medium text-gray-900 text-justify">
                      {key === 'discountMessage' ? 'Discount Message' : key.charAt(0).toUpperCase() + key.slice(1)}
                    </label>
                    <input

                      type="text"
                      placeholder={`${key === 'discountMessage' ? 'Discount Message' : key.charAt(0).toUpperCase() + key.slice(1)} (EN)`}
                      value={formData[key]?.en || ''}
                      onChange={(e) =>
                        setFormData((prev) => ({
                          ...prev,
                          [key]: { ...prev[key], en: e.target.value }
                        }))
                      }
                      className="flex-1 rounded-md bg-white px-4 py-3 text-gray-900 outline outline-1 -outline-offset-1 outline-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-indigo-600 focus:ring-offset-2 sm:text-sm"
                    />
                    <input

                      type="text"
                      placeholder={`${key === 'discountMessage' ? 'Discount Message' : key.charAt(0).toUpperCase() + key.slice(1)} (AR)`}
                      value={formData[key]?.ar || ''}
                      onChange={(e) =>
                        setFormData((prev) => ({
                          ...prev,
                          [key]: { ...prev[key], ar: e.target.value }
                        }))
                      }
                      className="flex-1 rounded-md bg-white px-4 py-3 text-gray-900 outline outline-1 -outline-offset-1 outline-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-indigo-600 focus:ring-offset-2 sm:text-sm"
                    />
                  </div>
                ))}

                <div className="flex items-center gap-4">
                  <label className="w-1/4 text-sm font-medium text-gray-900 text-justify">Email</label>
                  <input
                    type="text"
                    placeholder="Enter email"

                    value={formData.email}
                    onChange={(e) => setFormData({ ...formData, email: e.target.value })}
                    className="flex-1 rounded-md bg-white px-4 py-3 text-gray-900 border border-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-indigo-600 focus:ring-offset-2 sm:text-sm"
                  />

                </div>
                <div className="flex items-center gap-4">
                  <label className="w-1/4 text-sm font-medium text-gray-900 text-justify">Contact Number</label>
                  <input

                    type="text"
                    placeholder="Contact Number"
                    value={formData.contactNumber}
                    onChange={(e) => setFormData({ ...formData, contactNumber: correctContactValue(e.target.value) })}
                    className="flex-1 rounded-md bg-white px-4 py-3 text-gray-900 outline outline-1 -outline-offset-1 outline-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-indigo-600 focus:ring-offset-2 sm:text-sm"
                  />
                </div>

                {/* Discount URL Field */}
                <div className="flex items-center gap-4">
                  <label className="w-1/4 text-sm font-medium text-gray-900 text-justify">Discount URL</label>
                  <input
                    required
                    type="url"
                    value={formData.discountUrl || ''}
                    onChange={(e) =>
                      setFormData((prev) => ({
                        ...prev,
                        discountUrl: e.target.value
                      }))
                    }
                    placeholder="Enter discount URL"
                    className="flex-1 rounded-md bg-white px-4 py-3 text-gray-900 outline outline-1 -outline-offset-1 outline-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-indigo-600 focus:ring-offset-2 sm:text-sm"
                  />
                </div>

                <div className="flex items-center gap-4">
                  <label className="w-1/4 text-sm font-medium text-gray-900 text-justify">Rating</label>
                  <input

                    type="number"
                    min="1"
                    max="5"
                    value={formData.rating}
                    onChange={handleRatingChange}
                    className="flex-1 rounded-md bg-white px-4 py-3 text-gray-900 outline outline-1 -outline-offset-1 outline-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-indigo-600 focus:ring-offset-2 sm:text-sm"
                  />
                </div>



                <div className="flex items-center gap-4">
                  <label className="w-1/4 text-sm font-medium text-gray-900 text-justify">Social Links</label>
                  <div className="grid grid-cols-2 gap-4">
                    {[
                      { field: "website", label: "Website URL" },
                      { field: "facebook", label: "Facebook URL" },
                      { field: "instagram", label: "Instagram URL" },
                      { field: "twitter", label: "Twitter URL" },
                      { field: "youtube", label: "Yotube URL" },

                    ].map(({ field, label }) => (
                      <input
                        key={field}
                        type="text"
                        placeholder={label}
                        value={formData[field] || ""}
                        onChange={(e) => setFormData({ ...formData, [field]: e.target.value })}
                        className="w-full rounded-md bg-white px-4 py-3 text-gray-900 border border-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-indigo-600 focus:ring-offset-2 sm:text-sm"
                      />
                    ))}
                  </div>
                </div>



                <div className="grid grid-cols-12 gap-4">
                  <div className="col-span-3">
                    <label
                      htmlFor="cover-photo"
                      className="block text-sm font-medium text-gray-900 mb-2 text-justify"
                    >
                      Menu
                    </label>
                  </div>

                  <div className="col-span-9">
                    {formData.menus.length === 0 ? (
                      <div className="flex flex-col items-center rounded-lg border border-dashed border-gray-300 px-4 py-4">
                        <PhotoIcon
                          aria-hidden="true"
                          className="text-gray-300 h-12 w-12 mb-2"
                        />
                        <div className="flex items-center text-sm text-gray-600">
                          <label
                            htmlFor="file-upload-menus"
                            className="relative cursor-pointer rounded-md bg-white font-semibold text-indigo-600 focus-within:outline-none focus-within:ring-2 focus-within:ring-indigo-600 focus-within:ring-offset-2 hover:text-indigo-500"
                          >
                            <span>Upload a file</span>
                            <input
                              id="file-upload-menus"
                              name="file-upload"
                              type="file"
                              multiple
                              required
                              accept="image/jpeg,image/png,image/jpg"
                              onChange={(e) => handleImageUpload("menus", e.target.files)}
                              className="sr-only"
                            />
                          </label>
                          <p className="pl-2">or drag and drop</p>
                        </div>
                        <p className="mt-2 text-xs text-gray-500">PNG, JPG,JPEG up to 10MB</p>
                      </div>
                    ) : (
                      <div className="flex flex-wrap gap-4">
                        {formData.menus.map((url, index) => (
                          <div key={index} className="relative w-1/2 sm:w-1/3 lg:w-1/4">
                            <img
                              src={`${process.env.REACT_APP_IMAGE_URL}/${url}`}
                              className="w-full h-40 object-cover rounded-lg sm:h-32 lg:h-48"
                            />
                            <div onClick={() => handleRemoveImage("menus", index)} className="absolute top-2 right-2 z-10">
                              <TrashIcon className="h-6 w-6 text-gray-700 cursor-pointer" />
                            </div>
                          </div>
                        ))}
                        <div className="w-1/2 sm:w-1/3 lg:w-1/4 flex items-center justify-center">
                          <label
                            htmlFor="file-upload-menus"
                            className="relative cursor-pointer rounded-md bg-white font-semibold text-indigo-600 focus-within:outline-none focus-within:ring-2 focus-within:ring-indigo-600 focus-within:ring-offset-2 hover:text-indigo-500"
                          >
                            <span>Add Image</span>
                            <input
                              id="file-upload-menus"
                              name="file-upload"
                              type="file"
                              multiple

                              accept="image/jpeg,image/png,image/jpg"
                              onChange={(e) => handleImageUpload("menus", e.target.files)}
                              className="sr-only"
                            />
                          </label>
                        </div>
                      </div>
                    )}
                  </div>
                </div>

                {/* Gallery Upload Section */}
                <div className="grid grid-cols-12 gap-4">
                  <div className="col-span-3">
                    <label
                      htmlFor="cover-photo"
                      className="block text-sm font-medium text-gray-900 mb-2 text-justify"
                    >
                      Gallery
                    </label>
                  </div>

                  <div className="col-span-9">
                    {formData.gallery.length === 0 ? (
                      <div className="flex flex-col items-center rounded-lg border border-dashed border-gray-300 px-4 py-4">
                        <PhotoIcon
                          aria-hidden="true"
                          className="text-gray-300 h-12 w-12 mb-2"
                        />
                        <div className="flex items-center text-sm text-gray-600">
                          <label
                            htmlFor="file-upload-gallery"
                            className="relative cursor-pointer rounded-md bg-white font-semibold text-indigo-600 focus-within:outline-none focus-within:ring-2 focus-within:ring-indigo-600 focus-within:ring-offset-2 hover:text-indigo-500"
                          >
                            <span>Upload a file</span>
                            <input
                              id="file-upload-gallery"
                              name="file-upload"
                              type="file"
                              multiple
                              required
                              accept="image/jpeg,image/png,image/jpg"
                              onChange={(e) => handleImageUpload("gallery", e.target.files)}
                              className="sr-only"
                            />
                          </label>
                          <p className="pl-2">or drag and drop</p>
                        </div>
                        <p className="mt-2 text-xs text-gray-500">PNG, JPG,JPEG up to 10MB</p>
                      </div>
                    ) : (
                      <div className="flex flex-wrap gap-4">
                        {formData.gallery.map((url, index) => (
                          <div key={index} className="relative w-1/2 sm:w-1/3 lg:w-1/4">
                            <img
                              src={`${process.env.REACT_APP_IMAGE_URL}/${url}`}
                              className="w-full h-40 object-cover rounded-lg sm:h-32 lg:h-48"
                            />
                            <div onClick={() => handleRemoveImage("gallery", index)} className="absolute top-2 right-2 z-10">
                              <TrashIcon className="h-6 w-6 text-gray-700 cursor-pointer" />
                            </div>
                          </div>
                        ))}
                        <div className="w-1/2 sm:w-1/3 lg:w-1/4 flex items-center justify-center">
                          <label
                            htmlFor="file-upload-gallery"
                            className="relative cursor-pointer rounded-md bg-white font-semibold text-indigo-600 focus-within:outline-none focus-within:ring-2 focus-within:ring-indigo-600 focus-within:ring-offset-2 hover:text-indigo-500"
                          >
                            <span>Add Image</span>
                            <input
                              id="file-upload-gallery"
                              name="file-upload"
                              type="file"
                              multiple

                              accept="image/jpeg,image/png,image/jpg"
                              onChange={(e) => handleImageUpload("gallery", e.target.files)}
                              className="sr-only"
                            />
                          </label>
                        </div>
                      </div>
                    )}
                  </div>
                </div>

                {/* Buttons */}
                <div className="flex gap-2 mt-4">
                  <button
                    type="button"
                    onClick={handleCancel}
                    className="w-1/2 rounded-md bg-gray-500 px-4 py-3 text-white hover:bg-gray-600 focus:outline-none focus:ring-2 focus:ring-gray-400 focus:ring-offset-2 sm:text-sm"
                  >
                    Cancel
                  </button>
                  <button
                    type="submit"
                    className="w-1/2 rounded-md bg-indigo-600 px-4 py-3 text-white hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2 sm:text-sm"
                  >
                    {allmodel?.data?._id ? 'Update' : 'Add'}
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AddRestaurant;
